<template>
  <v-card>
    <v-card-title v-if="data" class="pa-0">
      <v-btn icon :disabled="page === 1" @click="page--">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <span>{{ chartTitle }}</span>
      <v-spacer></v-spacer>
      <span v-if="playable">
        <v-btn v-if="!update" icon @click="play">
          <v-icon>play_arrow</v-icon>
        </v-btn>
        <v-btn v-else icon @click="pause">
          <v-icon>pause</v-icon>
        </v-btn>
      </span>
      <v-btn
        v-if="allowDownloadData"
        icon
        @click="downloadData"
        :loading="downloadPending"
        :disabled="disabledDownload"
      >
        <v-icon>mdi-download</v-icon>
      </v-btn>
      <v-btn icon :disabled="page === numPages" @click="page++">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <component
        :is="chartComponent"
        :type="type"
        :options="chartOptions"
        :data="chartData"
        v-bind="props"
      ></component>
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from "@/components/charts/ChartJs.vue";
import Papa from "papaparse";
import download from "downloadjs";

export default {
  name: "ChartYearly",
  components: {
    Chart,
  },
  props: {
    chartComponent: {
      type: Object,
      required: false,
      default: () => Chart,
    },
    type: {
      type: String,
      required: false,
    },
    data: {
      type: [Object, Array],
      required: false,
      default: null,
    },
    options: {
      type: [Object, Array],
      required: false,
      default: null,
    },
    props: {
      type: Object,
      required: false,
      default: null,
    },
    startYear: {
      type: Number,
      required: false,
      default: null,
    },
    playable: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowDownloadData: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      update: null,
      interval: 2,
      downloadPending: false,
    };
  },
  computed: {
    numPages() {
      return this.data.length;
    },
    index() {
      return this.page - 1;
    },
    chartData() {
      if (Array.isArray(this.data)) {
        return this.data[this.index];
      }
      return this.data;
    },
    chartOptions() {
      if (Array.isArray(this.options)) {
        return this.options[this.index];
      }
      return this.options;
    },
    chartTitle() {
      return this.startYear
        ? `Year ${this.startYear + this.page - 1} (${this.page}/${this.numPages})`
        : `Year ${this.page}`;
    },
    disabledDownload() {
      return !this.data[this.page - 1];
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearTimeout(this.update);
  },
  methods: {
    next() {
      if (this.page + 1 > this.numPages) {
        this.page = 1;
      } else {
        this.page += 1;
      }
    },
    pause() {
      clearTimeout(this.update);
      this.update = null;
    },
    play() {
      this.next();
      this.update = setTimeout(this.play, this.interval * 1000);
    },
    downloadData() {
      this.downloadPending = true;
      const { name } = this.data[this.page - 1];
      let { value } = this.data[this.page - 1];
      // check if value is a single dimension array of numbers
      if (Array.isArray(value) && Number.isFinite(value[0])) {
        value = value.map((v) => ({ value: v }));
      }
      const csv = Papa.unparse(value);
      download(csv, `${name}.csv`, "text/csv");
      this.downloadPending = false;
    },
  },
};
</script>

<style></style>
